'use strict';

function updateFilterBadges ($marketingChecklist, category, checked) {
  var counterModifier = checked ? -1 : 1;
  var $filter = $marketingChecklist.find('#marketing-checklist-filter');
  var $filterItem = $filter.find('[data-tasks-category=' + category + ']');
  var filterItemCount = parseInt($filterItem.find('.badge').text(), 10);
  var filterTotal = parseInt(
    $filter.find('[data-tasks-category=all] .badge').text(), 10
  );
  var filterDone = parseInt(
    $filter.find('[data-tasks-category=done] .badge').text(), 10
  );

  $filterItem.find('.badge').text(filterItemCount + counterModifier);
  $filter.find('[data-tasks-category=all] .badge')
    .text(filterTotal + counterModifier);
  $filter.find('[data-tasks-category=done] .badge')
    .text(filterDone - counterModifier);
}

module.exports = updateFilterBadges;
